import { useState, useEffect, useCallback } from 'react';

export const useRetryableError = () => {
	const [capturedError, setCapturedError] = useState<Error | undefined>();
	const [hasReset, setHasReset] = useState(false);
	useEffect(() => {
		if (hasReset) {
			setCapturedError(undefined);
			setHasReset(false);
		}
	}, [hasReset]);
	const onRetry = useCallback(() => {
		setHasReset(true);
	}, []);
	return {
		onError: setCapturedError,
		onRetry,
		caughtError: hasReset ? capturedError : undefined,
	};
};
